import {
    InjectionToken,
    QueryList,
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { IGridState } from '@pages/generics/grid';
import { StorageService } from '@services';
import {
    FilterManager,
    IDropdownOption,
    IFilterModel,
    ISortModel,
    SortManager,
} from '@uipath/angular/components/ui-grid';
import { UiGridColumnDirective } from '@uipath/angular/components/ui-grid/body/ui-grid-column.directive';
import { UiGridHeaderDirective } from '@uipath/angular/components/ui-grid/header/ui-grid-header.directive';
import { ISuggestValue } from '@uipath/angular/components/ui-suggest';

import { Observable } from 'rxjs';
import { Omit } from 'type-fest';

export type GridFiltersState = Record<string, IDropdownOption | ISuggestValue>;

export interface IEncodedParams {
    sort?: Omit<ISortModel<{}>, 'title'>;
    filters?: GridFiltersState;
}

export type UrlPageState = Omit<Omit<PageEvent, 'previousPageIndex'>, 'length'>;

export interface IGridState<TEntity> {
    page: UrlPageState;
    sort: Omit<ISortModel<TEntity>, 'title'>;
    searchFilters: IFilterModel<TEntity>[];
    filters: IFilterModel<TEntity>[];
    expand: string[];
    select: string[];
}

export type IStoredGridState = Required<Omit<Omit<IGridParams, 'index'>, 'search'>>;

export interface IGridParams extends IEncodedParams {
    index: number;
    size: number;
    search?: string;
}

export enum GridUrlParamKeys {
    state = 'state',
    index = 'index',
    size = 'size',
    search = 'search',
}

export interface IGridUrlParams {
    [GridUrlParamKeys.state]?: string;
    [GridUrlParamKeys.index]?: number;
    [GridUrlParamKeys.size]?: number;
    [GridUrlParamKeys.search]?: string;
}

export interface IUrlGrid<TEntity> {
    appState: AppStateFacade;
    storageService: StorageService;
    destroyed$: Observable<unknown>;
    stateChange$: Observable<{}>;
    previousState: () => Readonly<IGridState<TEntity>>| undefined;
    state: () => Readonly<IGridState<TEntity>> | undefined;
    nextQuery: () => void;
    pageChange: (page: PageEvent) => void;
    columns: QueryList<UiGridColumnDirective<TEntity>>;
    filterManager: FilterManager<TEntity>;
    sortManager: SortManager<TEntity>;
    header: UiGridHeaderDirective<TEntity>;
    pageState: PageEvent;
    router: Router;
    storageKey: string;
}
export type GridStateHandler<TEntity> = (
    grid: IUrlGrid<TEntity>,
) => void;

export const STATE_HANDLER = new InjectionToken<GridStateHandler<{}>>('Grid-State-Handler');
